import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import React from "react";
import { EnforcementPolicyOption } from "common/graphql/fragments/enforcementIntentDetailFragment";

export interface EnforcementPolicySelectProps {
  enforcementPolicyOptions: EnforcementPolicyOption[];
  value: string | null;
  onChange: (policyId: string) => void;
}

export const EnforcementPolicySelect: React.FC<EnforcementPolicySelectProps> = ({
  enforcementPolicyOptions,
  value,
  onChange,
}) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value);
  };

  return (
    <FormControl fullWidth size="small">
      <Select value={value ?? ""} onChange={handleChange} displayEmpty>
        {enforcementPolicyOptions.map(({ id, code, description }) => (
          <MenuItem key={id} value={id}>
            {code} — {description}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default EnforcementPolicySelect;
